var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoTesty = function SvgLogoTesty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 321,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.58 0H39.35C17.618 0 0 17.618 0 39.35v242.23c0 21.732 17.618 39.35 39.35 39.35h242.23c21.732 0 39.35-17.618 39.35-39.35V39.35C320.93 17.618 303.312 0 281.58 0Z",
    fill: "#5DC0AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.38 119.56v81.82c0 22.59-9.16 43.04-23.96 57.85-14.81 14.8-35.27 23.96-57.86 23.96v-81.81c14.9 0 28.87-3.98 40.91-10.95a82.055 82.055 0 0 0 16.95-13.01c14.8-14.81 23.96-35.27 23.96-57.86ZM201.38 37.75c-14.9 0-28.87 3.98-40.91 10.95a82.055 82.055 0 0 0-16.95 13.01c-14.8 14.81-23.96 35.26-23.96 57.85H37.75c0-14.9 3.98-28.87 10.95-40.9a82.055 82.055 0 0 1 13.01-16.95c14.81-14.8 35.26-23.96 57.85-23.96h81.82Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.38 37.75v81.81c0 22.59-9.16 43.05-23.96 57.86a82.055 82.055 0 0 1-16.95 13.01c-12.04 6.97-26.01 10.95-40.91 10.95v-81.82c0-22.59 9.16-43.04 23.96-57.85a82.055 82.055 0 0 1 16.95-13.01c12.04-6.97 26.01-10.95 40.91-10.95ZM283.19 37.75c0 14.9-3.99 28.88-10.95 40.91a81.994 81.994 0 0 1-13.01 16.94c-14.81 14.8-35.26 23.96-57.85 23.96V37.75h81.81Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M201.38 37.75c-3.39 0-6.73.21-10.02.61a81.272 81.272 0 0 0-30.89 10.34 82.055 82.055 0 0 0-16.95 13.01c-14.8 14.81-23.96 35.26-23.96 57.85H89.41c0-22.59 9.16-43.04 23.97-57.85a81.994 81.994 0 0 1 16.94-13.01c12.05-6.97 26.01-10.95 40.91-10.95h30.15Z",
    fill: "url(#logo_testy_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_testy_svg__a",
    x1: 103.78,
    y1: 44.95,
    x2: 204.44,
    y2: 126.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F1F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CEE9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#94CFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4DAFAD"
  })))));
};
export default SvgLogoTesty;